import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

export const Route = createFileRoute("/_app/user-management/users/roles/$roleId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {roleId} = useParams({strict: false}) as {roleId: string};
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate
        params={{roleId}}
        replace
        to={routes.usermanagement.users.roles.role().permissions()}
      />
    );
  }

  return <div className="h-full w-full" ref={ref} />;
}
